/**
 * Sticky compliance banner shown on the Subscriber Verification Console.
 *
 * Reminds the founder this is a read-only cross-tenant view and that every
 * action is audited under Privacy Act APP 13.
 *
 * @see Plan: i-need-a-way-giggly-babbage.md (Wave 2 — Console UI)
 */

import React from 'react';
import { ShieldAlert } from 'lucide-react';

export interface SubscriberVerificationBannerProps {
  companyName: string;
  companyId: string;
}

export const SubscriberVerificationBanner: React.FC<SubscriberVerificationBannerProps> = ({
  companyName,
  companyId,
}) => {
  return (
    <div className="sticky top-0 z-30 -mx-8 px-8 py-3 bg-amber-500/10 backdrop-blur-md border-b border-amber-500/30 mb-6">
      <div className="flex items-center gap-3">
        <ShieldAlert className="w-5 h-5 text-amber-400 flex-shrink-0" />
        <div className="flex-1 text-sm">
          <span className="font-semibold text-amber-200">
            Founder read-only view
          </span>
          <span className="text-amber-100/90">
            {' '}— viewing{' '}
            <span className="font-mono font-semibold text-amber-50">{companyName}</span>
            {' '}
            <span className="text-amber-200/60">({companyId})</span>. All actions audited under Privacy Act APP 13.
          </span>
        </div>
      </div>
    </div>
  );
};

export default SubscriberVerificationBanner;
